import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "2:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-200.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "2:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-200.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
